/**
 * @generated SignedSource<<81cba04515f5629ca9ef3a326255e858>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
import { Semver } from "@/common/relayCustomScalar";
export type DatasetScaffoldVersionQuery$variables = {
  major: number;
  minor: number;
  owner: string;
  patch: number;
  slug: string;
};
export type DatasetScaffoldVersionQuery$data = {
  readonly datasetBySlug: {
    readonly version: {
      readonly version: Semver;
      readonly " $fragmentSpreads": FragmentRefs<"DatasetUseButtonFragment">;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"DatasetScaffoldFragment" | "DatasetVersionHistoryFragment">;
  } | null | undefined;
  readonly viewer: {
    readonly id: string;
    readonly viewerCanEdit: boolean;
    readonly viewerCanReadDatasetVersion: boolean;
  };
};
export type DatasetScaffoldVersionQuery = {
  response: DatasetScaffoldVersionQuery$data;
  variables: DatasetScaffoldVersionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "major"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "minor"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "owner"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "patch"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slug"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": "viewerCanEdit",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "UPDATE_DATASET"
    }
  ],
  "kind": "ScalarField",
  "name": "can",
  "storageKey": "can(action:\"UPDATE_DATASET\")"
},
v7 = {
  "alias": "viewerCanReadDatasetVersion",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "READ_DATASET_VERSION"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"READ_DATASET_VERSION\")"
},
v8 = [
  {
    "kind": "Variable",
    "name": "localSlug",
    "variableName": "slug"
  },
  {
    "kind": "Variable",
    "name": "owner",
    "variableName": "owner"
  }
],
v9 = [
  {
    "kind": "Variable",
    "name": "major",
    "variableName": "major"
  },
  {
    "kind": "Variable",
    "name": "minor",
    "variableName": "minor"
  },
  {
    "kind": "Variable",
    "name": "patch",
    "variableName": "patch"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "version",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v15 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isEntity"
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageThumbnail",
  "storageKey": null
},
v17 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v18 = [
  (v11/*:: as any*/),
  (v13/*:: as any*/),
  (v15/*:: as any*/),
  (v14/*:: as any*/),
  (v16/*:: as any*/),
  (v5/*:: as any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedAt",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v22 = [
  (v5/*:: as any*/),
  (v10/*:: as any*/)
],
v23 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DatasetScaffoldVersionQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          (v7/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v8/*:: as any*/),
        "concreteType": "Dataset",
        "kind": "LinkedField",
        "name": "datasetBySlug",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DatasetScaffoldFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DatasetVersionHistoryFragment"
          },
          {
            "alias": null,
            "args": (v9/*:: as any*/),
            "concreteType": "DatasetVersion",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              (v10/*:: as any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "DatasetUseButtonFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*:: as any*/),
      (v4/*:: as any*/),
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "DatasetScaffoldVersionQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v11/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          (v7/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v8/*:: as any*/),
        "concreteType": "Dataset",
        "kind": "LinkedField",
        "name": "datasetBySlug",
        "plural": false,
        "selections": [
          (v5/*:: as any*/),
          (v12/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "localSlug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "private",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shortDescription",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": [
              (v11/*:: as any*/),
              (v13/*:: as any*/),
              (v14/*:: as any*/),
              (v15/*:: as any*/),
              (v16/*:: as any*/),
              (v5/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v17/*:: as any*/),
            "concreteType": "DatasetVersionConnection",
            "kind": "LinkedField",
            "name": "versions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "DatasetVersionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DatasetVersion",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*:: as any*/),
                      (v10/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Dataset",
                        "kind": "LinkedField",
                        "name": "dataset",
                        "plural": false,
                        "selections": [
                          (v5/*:: as any*/),
                          (v12/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": (v18/*:: as any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DatasetAnalytics",
                        "kind": "LinkedField",
                        "name": "analytics",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "downloadCount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "fileSize",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "updatedAt",
                        "storageKey": null
                      },
                      (v19/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DOI",
                        "kind": "LinkedField",
                        "name": "doi",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "full",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "viewerCanDeleteDatasetVersion",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "action",
                            "value": "DELETE_DATASET_VERSION"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "viewerCan",
                        "storageKey": "viewerCan(action:\"DELETE_DATASET_VERSION\")"
                      },
                      {
                        "alias": "viewerCanUpdateDatasetVersion",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "action",
                            "value": "UPDATE_DATASET_VERSION"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "viewerCan",
                        "storageKey": "viewerCan(action:\"UPDATE_DATASET_VERSION\")"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "publishable",
                        "storageKey": null
                      },
                      {
                        "alias": "viewerCanPublishDatasetVersion",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "action",
                            "value": "PUBLISH_DATASET_VERSION"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "viewerCan",
                        "storageKey": "viewerCan(action:\"PUBLISH_DATASET_VERSION\")"
                      },
                      (v11/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v20/*:: as any*/)
                ],
                "storageKey": null
              },
              (v21/*:: as any*/)
            ],
            "storageKey": "versions(first:10)"
          },
          {
            "alias": null,
            "args": (v17/*:: as any*/),
            "filters": null,
            "handle": "connection",
            "key": "ListVersionHistoryFragment_versions",
            "kind": "LinkedHandle",
            "name": "versions"
          },
          {
            "alias": "versionsHelmet",
            "args": null,
            "concreteType": "DatasetVersionConnection",
            "kind": "LinkedField",
            "name": "versions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "DatasetVersion",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v5/*:: as any*/),
                  (v10/*:: as any*/),
                  (v19/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DatasetVersion",
            "kind": "LinkedField",
            "name": "latestVersion",
            "plural": false,
            "selections": (v22/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": "latestCreatedVersion",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 1
              }
            ],
            "concreteType": "DatasetVersionConnection",
            "kind": "LinkedField",
            "name": "versions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "DatasetVersion",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": (v22/*:: as any*/),
                "storageKey": null
              }
            ],
            "storageKey": "versions(first:1)"
          },
          {
            "alias": "versionsInput",
            "args": (v23/*:: as any*/),
            "concreteType": "DatasetVersionConnection",
            "kind": "LinkedField",
            "name": "versions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "DatasetVersionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DatasetVersion",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*:: as any*/),
                      (v10/*:: as any*/),
                      (v19/*:: as any*/),
                      (v11/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v20/*:: as any*/)
                ],
                "storageKey": null
              },
              (v21/*:: as any*/)
            ],
            "storageKey": "versions(first:20)"
          },
          {
            "alias": "versionsInput",
            "args": (v23/*:: as any*/),
            "filters": null,
            "handle": "connection",
            "key": "DatasetVersionCreateButtonFragment_versionsInput",
            "kind": "LinkedHandle",
            "name": "versions"
          },
          {
            "alias": "viewerCanCreateDatasetVersion",
            "args": [
              {
                "kind": "Literal",
                "name": "action",
                "value": "CREATE_DATASET_VERSION"
              }
            ],
            "kind": "ScalarField",
            "name": "viewerCan",
            "storageKey": "viewerCan(action:\"CREATE_DATASET_VERSION\")"
          },
          {
            "alias": null,
            "args": (v9/*:: as any*/),
            "concreteType": "DatasetVersion",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              (v10/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "DatasetVersionFileConnection",
                "kind": "LinkedField",
                "name": "files",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DatasetVersionFile",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "size",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      },
                      (v5/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Dataset",
                "kind": "LinkedField",
                "name": "dataset",
                "plural": false,
                "selections": [
                  (v12/*:: as any*/),
                  (v5/*:: as any*/)
                ],
                "storageKey": null
              },
              (v5/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "votes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "voterCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v17/*:: as any*/),
                "concreteType": "VotersConnection",
                "kind": "LinkedField",
                "name": "voters",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EntityEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v18/*:: as any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "voters(first:10)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EntityVote",
                "kind": "LinkedField",
                "name": "voted",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "score",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "viewerCanVote",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "action",
                    "value": "PUBLISH_VOTE"
                  }
                ],
                "kind": "ScalarField",
                "name": "viewerCan",
                "storageKey": "viewerCan(action:\"PUBLISH_VOTE\")"
              }
            ],
            "type": "Votable",
            "abstractKey": "__isVotable"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1a48967438f468519a595b1b28719c3c",
    "id": null,
    "metadata": {},
    "name": "DatasetScaffoldVersionQuery",
    "operationKind": "query",
    "text": "query DatasetScaffoldVersionQuery(\n  $owner: String!\n  $slug: String!\n  $major: Int!\n  $minor: Int!\n  $patch: Int!\n) {\n  viewer @ifAllowed {\n    __typename\n    id\n    viewerCanEdit: can(action: UPDATE_DATASET)\n    viewerCanReadDatasetVersion: viewerCan(action: READ_DATASET_VERSION)\n  }\n  datasetBySlug(owner: $owner, localSlug: $slug) {\n    ...DatasetScaffoldFragment\n    ...DatasetVersionHistoryFragment\n    version(major: $major, minor: $minor, patch: $patch) {\n      version\n      ...DatasetUseButtonFragment\n      id\n    }\n    id\n  }\n}\n\nfragment CardVersionHistoryFragment on DatasetVersion {\n  id\n  version\n  dataset {\n    id\n    slug\n    owner {\n      __typename\n      username\n      ...EntityProfilePicFragment_49kWkb\n      id\n    }\n  }\n  analytics {\n    downloadCount\n    fileSize\n  }\n  updatedAt\n  publishedAt\n  doi {\n    full\n  }\n  viewerCanDeleteDatasetVersion: viewerCan(action: DELETE_DATASET_VERSION)\n  viewerCanUpdateDatasetVersion: viewerCan(action: UPDATE_DATASET_VERSION)\n  ...DatasetVersionPublishButtonFragment\n}\n\nfragment DatasetScaffoldFragment on Dataset {\n  id\n  slug\n  localSlug\n  name\n  private\n  shortDescription\n  owner {\n    __typename\n    username\n    displayName\n    ...EntityProfilePicFragment_49kWkb\n    id\n  }\n  createdAt\n  ...VoteDisplayFragment\n}\n\nfragment DatasetUseButtonFragment on DatasetVersion {\n  version\n  files {\n    nodes {\n      size\n      url\n      id\n    }\n  }\n  dataset {\n    slug\n    id\n  }\n}\n\nfragment DatasetVersionCreateButtonFragment on Dataset {\n  id\n  latestVersion {\n    id\n    version\n  }\n  latestCreatedVersion: versions(first: 1) {\n    nodes {\n      id\n      version\n    }\n  }\n  versionsInput: versions(first: 20) {\n    edges {\n      node {\n        id\n        version\n        publishedAt\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment DatasetVersionHistoryFragment on Dataset {\n  slug\n  name\n  ...ListVersionHistoryFragment\n  ...DatasetVersionsHelmetFragment\n  ...DatasetVersionCreateButtonFragment\n  viewerCanCreateDatasetVersion: viewerCan(action: CREATE_DATASET_VERSION)\n}\n\nfragment DatasetVersionPublishButtonFragment on DatasetVersion {\n  id\n  version\n  publishable @ifAllowed\n  viewerCanPublishDatasetVersion: viewerCan(action: PUBLISH_DATASET_VERSION)\n}\n\nfragment DatasetVersionsHelmetFragment on Dataset {\n  name\n  slug\n  versionsHelmet: versions {\n    nodes {\n      id\n      version\n      publishedAt\n    }\n  }\n}\n\nfragment EntitiesAvatarFragment on VotersConnection {\n  edges {\n    node {\n      __typename\n      username\n      ...EntityProfilePicFragment_49kWkb\n      id\n    }\n  }\n}\n\nfragment EntityProfilePicFragment_49kWkb on Entity {\n  __isEntity: __typename\n  displayName\n  imageThumbnail\n}\n\nfragment ListVersionHistoryFragment on Dataset {\n  versions(first: 10) {\n    edges {\n      node {\n        id\n        ...CardVersionHistoryFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment VoteDisplayFragment on Votable {\n  __isVotable: __typename\n  id\n  votes\n  voterCount\n  voters(first: 10) {\n    ...EntitiesAvatarFragment\n  }\n  voted @ifAllowed {\n    score\n  }\n  viewerCanVote: viewerCan(action: PUBLISH_VOTE)\n}\n"
  }
};
})();

(node as any).hash = "b4982a15a6070f7149913d8675a97565";

export default node;
